export const TableCellWithSubtext = ({
  text,
  subText,
  style,
}: {
  text: string | React.ReactNode;
  subText: string | React.ReactNode;
  style?: React.CSSProperties;
}) => (
  <span style={{ textAlign: 'center', ...style }}>
    <p
      style={{
        margin: 0,
        fontSize: 24,
        fontWeight: 'bold',
      }}
    >
      {text}
    </p>
    <p
      style={{
        margin: 0,
        fontSize: 12,
        lineHeight: 1,
        fontWeight: 'normal',
        color: '#5D6C70',
      }}
    >
      {subText}
    </p>
  </span>
);
